// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DownloadLiabilitiesExportV2MutationVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
}>;


export type DownloadLiabilitiesExportV2Mutation = { __typename?: 'Mutation', exportLiabilityReportV2: { __typename?: 'FileDownloadToken', token: string, expiresInSeconds: number } };

export const Operations = {
  Mutation: {
    DownloadLiabilitiesExportV2: 'DownloadLiabilitiesExportV2' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const DownloadLiabilitiesExportV2Document = gql`
    mutation DownloadLiabilitiesExportV2($householdId: ID!) {
  exportLiabilityReportV2(householdID: $householdId) {
    token
    expiresInSeconds
  }
}
    `;
export type DownloadLiabilitiesExportV2MutationFn = Apollo.MutationFunction<DownloadLiabilitiesExportV2Mutation, DownloadLiabilitiesExportV2MutationVariables>;

/**
 * __useDownloadLiabilitiesExportV2Mutation__
 *
 * To run a mutation, you first call `useDownloadLiabilitiesExportV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadLiabilitiesExportV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadLiabilitiesExportV2Mutation, { data, loading, error }] = useDownloadLiabilitiesExportV2Mutation({
 *   variables: {
 *      householdId: // value for 'householdId'
 *   },
 * });
 */
export function useDownloadLiabilitiesExportV2Mutation(baseOptions?: Apollo.MutationHookOptions<DownloadLiabilitiesExportV2Mutation, DownloadLiabilitiesExportV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadLiabilitiesExportV2Mutation, DownloadLiabilitiesExportV2MutationVariables>(DownloadLiabilitiesExportV2Document, options);
      }
export type DownloadLiabilitiesExportV2MutationHookResult = ReturnType<typeof useDownloadLiabilitiesExportV2Mutation>;
export type DownloadLiabilitiesExportV2MutationResult = Apollo.MutationResult<DownloadLiabilitiesExportV2Mutation>;
export type DownloadLiabilitiesExportV2MutationOptions = Apollo.BaseMutationOptions<DownloadLiabilitiesExportV2Mutation, DownloadLiabilitiesExportV2MutationVariables>;